import { render, staticRenderFns } from "./CellMaxScore.vue?vue&type=template&id=2fdd6740&"
import script from "./CellMaxScore.vue?vue&type=script&lang=js&"
export * from "./CellMaxScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports